import React, { useState } from "react";
import { Button } from "@clarkinc/zest-design-system/ui";
import { User } from "~/common/Store/connectUserAndChat";
import ValidationError from "../AddToCart/ValidationError";
import { createVgSelectionError } from "../AddToCart/validations";
import isGroupMemberSelected from "../isGroupMemberSelected";
import { PricingProduct } from "../PricingProduct";
import getOrderGuideData, { OrderGuideData } from "./getOrderGuideData";
import OrderGuideModal from "./OrderGuideModal";
interface Props {
  user: User;
  quantity: string;
  product: PricingProduct;
  handleVgSelectionError: (validationError: ValidationError) => void;
}
export default ({
  user,
  quantity,
  product,
  handleVgSelectionError
}: Props) => {
  const {
    itemNumber,
    header,
    productImages
  } = product;
  const imagePath = productImages?.find(x => x.isPrimaryDetailImage)?.thumbnail || "";
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [hasOrderGuideData, setHasOrderGuideData] = useState(false);
  const [orderGuideData, setOrderGuideData] = useState<OrderGuideData>({
    categories: [],
    subordinateAccounts: []
  });
  const handleOnClick = async () => {
    if (!isGroupMemberSelected(product)) {
      handleVgSelectionError(createVgSelectionError());
      return;
    }
    setIsModalOpen(true);
    if (!hasOrderGuideData) {
      const result = await getOrderGuideData(itemNumber);
      if (result) {
        setHasOrderGuideData(true);
        setOrderGuideData(result);
      }
    }
  };
  return <>
      {user.orderGuideEnabled && <>
          <Button theme="wss" color="gray" size="small" type="button" full onClick={handleOnClick} className="ml-2 md:ml-2.5 mr-5 whitespace-nowrap font-proxima focus:bg-gray-50">
            Add to Order Guide
          </Button>
          {isModalOpen && <OrderGuideModal hasOrderGuideData={hasOrderGuideData} isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} orderGuideData={orderGuideData} userIndex={user.index || ""} key={isModalOpen.toString()} itemNumber={itemNumber} itemDescription={header} imagePath={imagePath} quantity={quantity} />}
        </>}
    </>;
};